import React, { useState } from "react";
import { Box, Button, Tooltip } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from "notistack";

interface CopyToClipboardProps {
  text: string; // The text to copy to the clipboard
  buttonLabel?: string; // Optional label for the button
}

const CopyToClipboard: React.FC<CopyToClipboardProps> = (props) => {
  const { i18n } = useTranslation();
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(props.text);
      setTooltipOpen(true);
      setTimeout(() => setTooltipOpen(false), 2000); // Hide tooltip after 2 seconds
    } catch (err) {
      setTooltipOpen(false);
      enqueueSnackbar(`${i18n.t("resource-action.copy-dashboard-url-error")}: ${err}`, {variant: "error", persist: true});
    }
  };

  return (
    <Tooltip
      title="Copied!"
      open={tooltipOpen}
      followCursor={true}
    >
      <Box>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<ContentCopy />}
          onClick={handleCopy}
        >
          {props.buttonLabel ? props.buttonLabel : i18n.t("copy")}
        </Button>
      </Box>
    </Tooltip>
  );
};

export default CopyToClipboard;